// TODO Remove when livesearch-source-metadata-platform lock is removed
export const SOCIAL_SOURCES = [
  "twitter",
  "telegram",
  "instagram",
  "facebook",
  "reddit",
  "youtube",
  "weibo",
  "vk",
  "toutiao",
];
